import React from 'react'
import { useTranslation } from 'react-i18next'
import { Paragraph, Button, LayoutBand, Row, colors, Image, Separator, useContainerWidth, H1 } from '@fs/zion-ui'
import image from './portal-error.svg'

export default function ErrorBoundaryFallback() {
  const isNarrow = useContainerWidth()({ default: true, sm: false })
  const { t } = useTranslation()
  return (
    <LayoutBand
      color={colors.gray02}
      minHeight="calc(var(--layout-viewport-height) - var(--header-height))"
      alignY={!isNarrow ? 'middle' : undefined}
    >
      <Separator size={isNarrow ? 'xxl' : 'sm'} />
      <Row alignX="center">
        <Image maxHeight={315} maxWidth="100%" src={image} alt="" />
      </Row>
      <Separator size="md" />
      <H1 size="H5" centered supplementary>
        {t('error-boundary-fallback.heading', 'Sorry, there was a problem.')}
      </H1>
      <Separator size="xxs" />
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <Paragraph centered size="sm">
          {t(
            'error-boundary-fallback.body',
            "You can try refreshing the page. If it still doesn't work, you can report the problem to our support team."
          )}
        </Paragraph>
      </div>
      <Row alignX="center">
        <Button to="/fieldops/familysearch-support-contact-us" external>
          {t('error-boundary-fallback.button', 'Contact Support')}
        </Button>
      </Row>
      {isNarrow && <Separator size="sm" />}
    </LayoutBand>
  )
}
